import { useReadCalendar } from "@clockwise/web-commons/src/util/CalendarContext";

export const useOnSplitView = () => {
  const { visibleDates } = useReadCalendar();

  return visibleDates.length === 1;
};
